// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "console-app." + "053b664470c701523f1f" + ".js";
};